module.exports = __webpack_public_path__ + "static/media/createComment.04988118.png";